/* Pied de page repliable sur telephone.
   Sans JavaScript, les colonnes restent ouvertes : rien n'est cache. */
(function () {
  var SEUIL = 700;

  function corps(col) {
    var e = col.firstElementChild;
    while (e) {
      if (e.tagName === 'UL' || (e.className || '').toString().indexOf('rt') > -1) return e;
      e = e.nextElementSibling;
    }
    return null;
  }

  function basculer(h, ev) {
    if (window.innerWidth > SEUIL) return;
    /* mi.js referme les panneaux ouverts a chaque clic du document et remet
       tous les aria-expanded a false : on garde ce clic pour nous, et on
       reaffirme l'etat au tour suivant par securite. */
    if (ev) ev.stopPropagation();
    var col = h.parentElement;
    var ouvert = col.classList.toggle('open');
    var poser = function () { h.setAttribute('aria-expanded', ouvert ? 'true' : 'false'); };
    poser();
    setTimeout(poser, 0);
  }

  /* les ecouteurs ne sont poses qu'une fois, quelle que soit la largeur */
  function brancher() {
    document.querySelectorAll('.ft-col').forEach(function (col) {
      var h = col.querySelector('h3');
      if (!h || h.dataset.acc === '1' || !corps(col)) return;
      h.dataset.acc = '1';
      h.addEventListener('click', function (e) { basculer(h, e); });
      h.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') { e.preventDefault(); basculer(h, e); }
      });
    });
  }

  function regler() {
    var petit = window.innerWidth <= SEUIL;
    document.querySelectorAll('.ft-col').forEach(function (col) {
      var h = col.querySelector('h3');
      if (!h || !corps(col)) return;
      if (petit) {
        col.classList.add('ft-acc');
        h.setAttribute('role', 'button');
        h.setAttribute('tabindex', '0');
        /* l'etat annonce suit toujours l'etat reel */
        h.setAttribute('aria-expanded', col.classList.contains('open') ? 'true' : 'false');
      } else {
        col.classList.remove('ft-acc', 'open');
        h.removeAttribute('role');
        h.removeAttribute('tabindex');
        h.removeAttribute('aria-expanded');
      }
    });
  }

  function demarrer() { brancher(); regler(); }

  var t;
  window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(regler, 160); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrer);
  else demarrer();
})();
